(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-timeline"] && !Shopify.designMode) return;
  try {
    
  // Scroll choreography for the about timeline: rows reveal once as they enter
  // the viewport, and the spine's progress line tracks reading position.
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.about-timeline').forEach(function (root) {
      var rows = Array.prototype.slice.call(root.querySelectorAll('.about-timeline__row'));
      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (!reduced && 'IntersectionObserver' in window) {
        root.classList.add('is-animated');

        var io = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                entry.target.classList.add('is-inview');
                io.unobserve(entry.target);
              }
            });
          },
          { threshold: 0.15, rootMargin: '0px 0px -12% 0px' }
        );

        rows.forEach(function (row) {
          io.observe(row);
        });
      } else {
        rows.forEach(function (row) {
          row.classList.add('is-inview');
        });
      }

      var progress = root.querySelector('.about-timeline__spine-progress');
      if (!progress) return;

      if (reduced) {
        progress.style.transform = 'scaleY(1)';
        return;
      }

      var ticking = false;

      var update = function () {
        var rect = root.getBoundingClientRect();
        var anchor = window.innerHeight * 0.66;
        var p = (anchor - rect.top) / rect.height;
        p = Math.max(0, Math.min(1, p));
        progress.style.transform = 'scaleY(' + p + ')';
      };

      var onScroll = function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          update();
          ticking = false;
        });
      };

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      update();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["card-carousel"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var roots = document.querySelectorAll('[data-card-carousel]');

    roots.forEach(function (root) {
      var viewport = root.querySelector('[data-card-carousel-viewport]');
      if (!viewport || !window.EmblaCarousel) return;

      var embla = EmblaCarousel(viewport, {
        align: 'start',
        containScroll: 'trimSnaps',
        dragFree: false,
        loop: false,
        slidesToScroll: 1,
        breakpoints: {
          '(min-width: 1024px)': { slidesToScroll: 1 },
        },
      });

      var controls = root.querySelector('[data-card-carousel-controls]');
      var prevBtn = root.querySelector('[data-card-carousel-prev]');
      var nextBtn = root.querySelector('[data-card-carousel-next]');

      if (prevBtn)
        prevBtn.addEventListener('click', function () {
          embla.scrollPrev();
        });
      if (nextBtn)
        nextBtn.addEventListener('click', function () {
          embla.scrollNext();
        });

      var toggleControls = function () {
        if (!controls) return;
        var canScroll = embla.canScrollPrev() || embla.canScrollNext();
        controls.style.display = canScroll ? '' : 'none';
      };

      embla.on('reInit', toggleControls);
      toggleControls();

      var progressNode = root.querySelector('[data-card-carousel-progress]');
      var progressTrack = root.querySelector('[data-card-carousel-progress-track]');
      if (!progressNode) return;

      var updateProgress = function () {
        var progress = embla.scrollProgress();
        var clamped = Math.max(0, Math.min(1, progress));
        var minFill = 0.15;
        var fill = minFill + clamped * (1 - minFill);
        progressNode.style.transform = 'scaleX(' + fill + ')';
      };

      embla.on('scroll', updateProgress);
      embla.on('reInit', updateProgress);
      updateProgress();

      if (!progressTrack) return;

      var snapList = embla.scrollSnapList();
      var isPointerDown = false;

      var findClosestSnap = function (progress) {
        var closestIndex = 0;
        var closestDistance = Math.abs(snapList[0] - progress);
        snapList.forEach(function (snap, index) {
          var distance = Math.abs(snap - progress);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });
        return closestIndex;
      };

      var moveToProgress = function (event) {
        var rect = progressTrack.getBoundingClientRect();
        var raw = (event.clientX - rect.left) / rect.width;
        var clamped = Math.max(0, Math.min(1, raw));
        embla.scrollTo(findClosestSnap(clamped));
      };

      var onPointerDown = function (event) {
        isPointerDown = true;
        progressTrack.setPointerCapture(event.pointerId);
        moveToProgress(event);
      };

      var onPointerMove = function (event) {
        if (!isPointerDown) return;
        moveToProgress(event);
      };

      var onPointerUp = function (event) {
        if (!isPointerDown) return;
        isPointerDown = false;
        progressTrack.releasePointerCapture(event.pointerId);
      };

      progressTrack.addEventListener('pointerdown', onPointerDown);
      progressTrack.addEventListener('pointermove', onPointerMove);
      progressTrack.addEventListener('pointerup', onPointerUp);
      progressTrack.addEventListener('pointercancel', onPointerUp);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-products"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCarousel(root) {
      if (!window.EmblaCarousel) return;
      if (root.dataset.showControls !== 'true') return;

      var viewport = root.querySelector('[data-collection-products-viewport]');
      var prevBtn = root.querySelector('[data-collection-products-prev]');
      var nextBtn = root.querySelector('[data-collection-products-next]');
      var progressBar = root.querySelector('[data-collection-products-progress-bar]');
      var progressTrack = root.querySelector('[data-collection-products-progress-track]');
      if (!viewport) return;

      var desktopColumns = Number(root.dataset.desktopColumns) || 4;

      var embla = EmblaCarousel(viewport, {
        align: 'start',
        containScroll: 'trimSnaps',
        dragFree: false,
        loop: false,
        slidesToScroll: 1,
        breakpoints: {
          '(min-width: 1024px)': { slidesToScroll: Math.max(1, Math.floor(desktopColumns / 2)) }
        }
      });

      if (prevBtn) prevBtn.addEventListener('click', function () { embla.scrollPrev(); });
      if (nextBtn) nextBtn.addEventListener('click', function () { embla.scrollNext(); });

      if (progressBar) {
        var updateProgress = function () {
          var progress = embla.scrollProgress();
          var clamped = Math.max(0, Math.min(1, progress));
          var minFill = 0.15;
          var fill = minFill + clamped * (1 - minFill);
          progressBar.style.transform = 'scaleX(' + fill + ')';
        };
        embla.on('scroll', updateProgress);
        embla.on('reInit', updateProgress);
        updateProgress();
      }

      if (progressTrack) {
        var snapList = embla.scrollSnapList();
        var isPointerDown = false;

        var findClosestSnap = function (progress) {
          var closestIndex = 0;
          var closestDistance = Math.abs(snapList[0] - progress);
          snapList.forEach(function (snap, index) {
            var distance = Math.abs(snap - progress);
            if (distance < closestDistance) {
              closestDistance = distance;
              closestIndex = index;
            }
          });
          return closestIndex;
        };

        var moveToProgress = function (event) {
          var rect = progressTrack.getBoundingClientRect();
          var raw = (event.clientX - rect.left) / rect.width;
          var clamped = Math.max(0, Math.min(1, raw));
          embla.scrollTo(findClosestSnap(clamped));
        };

        progressTrack.addEventListener('pointerdown', function (event) {
          isPointerDown = true;
          progressTrack.setPointerCapture(event.pointerId);
          moveToProgress(event);
        });
        progressTrack.addEventListener('pointermove', function (event) {
          if (isPointerDown) moveToProgress(event);
        });
        var release = function (event) {
          if (!isPointerDown) return;
          isPointerDown = false;
          if (progressTrack.hasPointerCapture(event.pointerId)) {
            progressTrack.releasePointerCapture(event.pointerId);
          }
        };
        progressTrack.addEventListener('pointerup', release);
        progressTrack.addEventListener('pointercancel', release);
      }
    }

    function initAll() {
      document.querySelectorAll('[data-collection-products-carousel]').forEach(initCarousel);
    }

    function whenEmblaReady() {
      if (window.EmblaCarousel) {
        initAll();
        return;
      }
      var attempts = 0;
      var interval = setInterval(function () {
        attempts++;
        if (window.EmblaCarousel) {
          clearInterval(interval);
          initAll();
        } else if (attempts > 50) {
          clearInterval(interval);
        }
      }, 100);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', whenEmblaReady);
    } else {
      whenEmblaReady();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  document.addEventListener('alpine:init', () => {
    Alpine.data('infiniteScroll', () => ({
      loading: false,
      hasMore: true,
      nextUrl: null,
      observer: null,

      init() {
        this.nextUrl = this.$el.dataset.nextUrl || null;
        const totalPages = parseInt(this.$el.dataset.totalPages, 10);
        const currentPage = parseInt(this.$el.dataset.currentPage, 10);

        this.hasMore = currentPage < totalPages && this.nextUrl;

        if (!this.hasMore) return;

        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting && !this.loading && this.hasMore) {
                this.loadMore();
              }
            });
          },
          { rootMargin: '400px' }
        );

        this.observer.observe(this.$refs.sentinel);
      },

      async loadMore() {
        if (this.loading || !this.nextUrl) return;

        this.loading = true;

        try {
          const response = await fetch(this.nextUrl, {
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
          });
          const html = await response.text();
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newGrid = doc.querySelector('[x-data="infiniteScroll"]');

          if (!newGrid) {
            this.hasMore = false;
            return;
          }

          const newItems = newGrid.querySelectorAll(':scope > [data-product-card]');
          const sentinel = this.$refs.sentinel;

          newItems.forEach((item) => {
            this.$el.insertBefore(item, sentinel);
          });

          this.nextUrl = newGrid.dataset.nextUrl || null;
          const newTotalPages = parseInt(newGrid.dataset.totalPages, 10);
          const newCurrentPage = parseInt(newGrid.dataset.currentPage, 10);

          this.hasMore = newCurrentPage < newTotalPages && this.nextUrl;

          if (!this.hasMore && this.observer) {
            this.observer.disconnect();
          }
        } catch (error) {
          console.error('Infinite scroll error:', error);
          this.hasMore = false;
        } finally {
          this.loading = false;
        }
      },

      destroy() {
        if (this.observer) {
          this.observer.disconnect();
        }
      },
    }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["designer-products"] && !Shopify.designMode) return;
  try {
    
  const DESIGNER_PRODUCTS_STOREFRONT_ACCESS_TOKEN = '7b02298c30f2691eec82daa4ff18aa95';
  const DESIGNER_PRODUCTS_API_VERSION = '2026-01';
  const DESIGNER_PRODUCTS_API_PAGE_SIZE = 100;
  const DESIGNER_PRODUCTS_METAFIELD_NAMESPACE = 'custom';
  const DESIGNER_PRODUCTS_METAFIELD_KEY = 'designer';

  const DESIGNER_PRODUCTS_GRAPHQL_QUERY = `
    query DesignerProducts($first: Int!, $after: String, $query: String, $namespace: String!, $key: String!) {
      products(first: $first, after: $after, query: $query, sortKey: CREATED_AT) {
        nodes {
          title
          handle
          featuredImage {
            url
            altText
          }
          metafield(namespace: $namespace, key: $key) {
            value
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  `;

  const designerProductsDefaults = {
    mobileColumns: '1',
    placeholderSvg: ''
  };

  function parseDesignerProductsConfig(rootElement) {
    try {
      return {
        ...designerProductsDefaults,
        ...JSON.parse(rootElement.dataset.designerProductsConfig || '{}')
      };
    } catch (error) {
      console.error('Designer products config parse failed', error);
      return { ...designerProductsDefaults };
    }
  }

  document.addEventListener('alpine:init', () => {
    Alpine.data('designerProductsCarousel', (rootElement) => ({
      config: parseDesignerProductsConfig(rootElement),
      embla: null,
      progressHandlers: null,
      hasSlides: false,
      showControls: false,
      isStaticLayout: false,
      isLoaded: false,
      isLoading: true,
      apiCursor: null,
      hasNextPage: true,
      productsRendered: 0,

      async init() {
        this.resetState();
        await this.fetchAndRenderProducts();
        this.isLoaded = true;
        this.isLoading = false;
      },

      destroy() {
        this.teardownProgress();

        if (this.embla) {
          this.embla.destroy();
          this.embla = null;
        }
      },

      resetState() {
        this.hasSlides = false;
        this.showControls = false;
        this.isStaticLayout = false;
        this.isLoaded = false;
        this.isLoading = true;
        this.apiCursor = null;
        this.hasNextPage = true;
        this.productsRendered = 0;

        if (this.$refs.container) {
          this.$refs.container.replaceChildren();
        }
      },

      get loaderCount() {
        return 4;
      },

      get loaderSlideStyle() {
        return `--mobile-slide-basis: ${this.getMobileSlideBasis()};`;
      },

      get containerStyle() {
        if (!this.isStaticLayout) {
          return null;
        }

        const mobileColumns = Number(this.config.mobileColumns) === 2 ? 2 : 1;
        const desktopColumns = Math.max(1, Math.min(this.productsRendered, 4));
        return `--designer-products-mobile-columns: ${mobileColumns}; --designer-products-desktop-columns: ${desktopColumns};`;
      },

      get apiEndpoint() {
        return `${window.location.origin}/api/${DESIGNER_PRODUCTS_API_VERSION}/graphql.json`;
      },

      get pageSize() {
        return DESIGNER_PRODUCTS_API_PAGE_SIZE;
      },

      buildQuery() {
        const designerGid = this.config.designerGid;
        return `metafields.${DESIGNER_PRODUCTS_METAFIELD_NAMESPACE}.${DESIGNER_PRODUCTS_METAFIELD_KEY}:\"${designerGid}\"`;
      },

      getMobileSlideBasis() {
        return Number(this.config.mobileColumns) === 2 ? 'calc(50% - 0.5rem)' : 'calc(100% - 0.5rem)';
      },

      buildImageMarkup(product, title) {
        if (!product.featuredImage) {
          return `<div class="w-full h-full flex items-center justify-center bg-neutral-200">${this.config.placeholderSvg}</div>`;
        }

        return `<img src="${this.escapeHtml(product.featuredImage.url)}" alt="${this.escapeHtml(product.featuredImage.altText || title)}" loading="lazy" class="size-full object-contain">`;
      },

      createSlideMarkup(product) {
        const productUrl = product.handle ? `/products/${product.handle}` : '#';
        const title = this.escapeHtml(product.title || '');
        const mobileBasis = this.getMobileSlideBasis();

        return `
          <div class="designer-products-embla__slide min-h-full border-b border-b-(--color-border)" style="--mobile-slide-basis: ${mobileBasis};">
            <a href="${productUrl}" class="group contents">
              <div class="aspect-4/5 overflow-hidden bg-white">
                ${this.buildImageMarkup(product, title)}
              </div>
              <div class="pt-4 pb-4">
                <h3 class="text-sm font-normal leading-snug capitalize">${title}</h3>
              </div>
            </a>
          </div>
        `;
      },

      escapeHtml(value) {
        return String(value)
          .replaceAll('&', '&amp;')
          .replaceAll('<', '&lt;')
          .replaceAll('>', '&gt;')
          .replaceAll('"', '&quot;')
          .replaceAll("'", '&#39;');
      },

      isProductMatch(product) {
        const metafieldValue = product.metafield?.value || '';
        return metafieldValue.includes(this.config.designerGid);
      },

      appendProducts(products) {
        const markup = products.map((product) => this.createSlideMarkup(product)).join('');
        this.$refs.container.insertAdjacentHTML('beforeend', markup);
        this.productsRendered += products.length;
      },

      async fetchPage() {
        const variables = {
          first: this.pageSize,
          after: this.apiCursor,
          query: this.buildQuery(),
          namespace: DESIGNER_PRODUCTS_METAFIELD_NAMESPACE,
          key: DESIGNER_PRODUCTS_METAFIELD_KEY
        };

        const response = await fetch(this.apiEndpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': DESIGNER_PRODUCTS_STOREFRONT_ACCESS_TOKEN
          },
          body: JSON.stringify({ query: DESIGNER_PRODUCTS_GRAPHQL_QUERY, variables })
        });

        if (!response.ok) {
          throw new Error(`Storefront API request failed with status ${response.status}`);
        }

        const data = await response.json();
        if (data.errors && data.errors.length > 0) {
          throw new Error(data.errors[0].message || 'Storefront API query failed');
        }

        return data.data.products;
      },

      async fetchAndRenderProducts() {
        if (!this.$refs.container) {
          this.isLoading = false;
          return;
        }

        try {
          const matchedProducts = [];

          while (this.hasNextPage) {
            const page = await this.fetchPage();
            this.hasNextPage = page.pageInfo.hasNextPage;
            this.apiCursor = page.pageInfo.endCursor;

            const matchingProducts = page.nodes.filter((product) => this.isProductMatch(product));

            if (matchingProducts.length > 0) {
              matchedProducts.push(...matchingProducts);
            }
          }

          if (matchedProducts.length > 0) {
            this.appendProducts(matchedProducts);
          }

          this.hasSlides = this.productsRendered > 0;
          this.showControls = this.productsRendered > 4;
          this.isStaticLayout = this.hasSlides && !this.showControls;

          if (this.showControls) {
            this.initEmbla();
          }
        } catch (error) {
          console.error('Designer products fetch failed', error);
        } finally {
          this.isLoading = false;
        }
      },

      initEmbla() {
        if (!this.$refs.viewport || !window.EmblaCarousel) {
          return;
        }

        const slideCount = this.$refs.viewport.querySelectorAll('.designer-products-embla__slide').length;
        if (slideCount === 0) {
          return;
        }

        if (this.embla) {
          this.embla.destroy();
          this.embla = null;
        }

        this.embla = EmblaCarousel(this.$refs.viewport, {
          align: 'start',
          containScroll: 'trimSnaps',
          dragFree: false,
          loop: false,
          slidesToScroll: 1,
          breakpoints: {
            '(min-width: 1024px)': { slidesToScroll: 2 }
          }
        });

        this.bindProgress();
      },

      scrollPrev() {
        if (this.embla) {
          this.embla.scrollPrev();
        }
      },

      scrollNext() {
        if (this.embla) {
          this.embla.scrollNext();
        }
      },

      bindProgress() {
        if (!this.embla || !this.$refs.progressBar) {
          return;
        }

        this.teardownProgress();

        const progressBar = this.$refs.progressBar;
        const progressTrack = this.$refs.progressTrack;

        const updateProgress = () => {
          const progress = this.embla.scrollProgress();
          const clampedProgress = Math.max(0, Math.min(1, progress));
          const minFill = 0.15;
          const fill = minFill + clampedProgress * (1 - minFill);

          progressBar.style.transform = `scaleX(${fill})`;
        };

        this.embla.on('scroll', updateProgress);
        this.embla.on('reInit', updateProgress);
        updateProgress();

        if (!progressTrack) {
          return;
        }

        const snapList = this.embla.scrollSnapList();
        let isPointerDown = false;

        const findClosestSnap = (progress) => {
          let closestIndex = 0;
          let closestDistance = Math.abs(snapList[0] - progress);

          snapList.forEach((snap, index) => {
            const distance = Math.abs(snap - progress);
            if (distance < closestDistance) {
              closestDistance = distance;
              closestIndex = index;
            }
          });

          return closestIndex;
        };

        const moveToProgress = (event) => {
          const rect = progressTrack.getBoundingClientRect();
          const raw = (event.clientX - rect.left) / rect.width;
          const clamped = Math.max(0, Math.min(1, raw));
          const index = findClosestSnap(clamped);
          this.embla.scrollTo(index);
        };

        const onPointerDown = (event) => {
          isPointerDown = true;
          progressTrack.setPointerCapture(event.pointerId);
          moveToProgress(event);
        };

        const onPointerMove = (event) => {
          if (!isPointerDown) {
            return;
          }

          moveToProgress(event);
        };

        const onPointerUp = (event) => {
          if (!isPointerDown) {
            return;
          }

          isPointerDown = false;
          if (progressTrack.hasPointerCapture(event.pointerId)) {
            progressTrack.releasePointerCapture(event.pointerId);
          }
        };

        progressTrack.addEventListener('pointerdown', onPointerDown);
        progressTrack.addEventListener('pointermove', onPointerMove);
        progressTrack.addEventListener('pointerup', onPointerUp);
        progressTrack.addEventListener('pointercancel', onPointerUp);

        this.progressHandlers = {
          progressTrack,
          onPointerDown,
          onPointerMove,
          onPointerUp
        };
      },

      teardownProgress() {
        if (!this.progressHandlers) {
          return;
        }

        const { progressTrack, onPointerDown, onPointerMove, onPointerUp } = this.progressHandlers;
        progressTrack.removeEventListener('pointerdown', onPointerDown);
        progressTrack.removeEventListener('pointermove', onPointerMove);
        progressTrack.removeEventListener('pointerup', onPointerUp);
        progressTrack.removeEventListener('pointercancel', onPointerUp);
        this.progressHandlers = null;
      }
    }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var emblaRoots = document.querySelectorAll('[data-featured-embla]');

    emblaRoots.forEach(function (root) {
      var viewport = root.querySelector('[data-featured-embla-viewport]');
      if (!viewport || !window.EmblaCarousel) {
        return;
      }

      var embla = EmblaCarousel(viewport, {
        align: 'start',
        containScroll: 'trimSnaps',
        dragFree: false,
        loop: false,
        slidesToScroll: 1,
        breakpoints: {
          '(min-width: 1024px)': { slidesToScroll: 2 }
        }
      });

      var prevBtn = root.querySelector('[data-featured-embla-prev]');
      var nextBtn = root.querySelector('[data-featured-embla-next]');

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          embla.scrollPrev();
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          embla.scrollNext();
        });
      }

      var progressNode = root.querySelector('[data-featured-embla-progress]');
      var progressTrack = root.querySelector('[data-featured-embla-progress-track]');
      if (!progressNode) {
        return;
      }

      var updateProgress = function () {
        var progress = embla.scrollProgress();
        var clampedProgress = Math.max(0, Math.min(1, progress));
        var minFill = 0.15;
        var fill = minFill + clampedProgress * (1 - minFill);
        progressNode.style.transform = 'scaleX(' + fill + ')';
      };

      embla.on('scroll', updateProgress);
      embla.on('reInit', updateProgress);
      updateProgress();

      if (!progressTrack) {
        return;
      }

      var snapList = embla.scrollSnapList();
      var isPointerDown = false;

      var findClosestSnap = function (progress) {
        var closestIndex = 0;
        var closestDistance = Math.abs(snapList[0] - progress);

        snapList.forEach(function (snap, index) {
          var distance = Math.abs(snap - progress);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });

        return closestIndex;
      };

      var moveToProgress = function (event) {
        var rect = progressTrack.getBoundingClientRect();
        var raw = (event.clientX - rect.left) / rect.width;
        var clamped = Math.max(0, Math.min(1, raw));
        var index = findClosestSnap(clamped);
        embla.scrollTo(index);
      };

      var onPointerDown = function (event) {
        isPointerDown = true;
        progressTrack.setPointerCapture(event.pointerId);
        moveToProgress(event);
      };

      var onPointerMove = function (event) {
        if (!isPointerDown) {
          return;
        }

        moveToProgress(event);
      };

      var onPointerUp = function (event) {
        if (!isPointerDown) {
          return;
        }

        isPointerDown = false;
        progressTrack.releasePointerCapture(event.pointerId);
      };

      progressTrack.addEventListener('pointerdown', onPointerDown);
      progressTrack.addEventListener('pointermove', onPointerMove);
      progressTrack.addEventListener('pointerup', onPointerUp);
      progressTrack.addEventListener('pointercancel', onPointerUp);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-projects"] && !Shopify.designMode) return;
  try {
    
  // Hidden accordion panels keep their images lazy (zero cost at page load).
  // Once the section comes within one viewport of the user, flip them to
  // eager so every panel's image is already downloaded before it is opened.
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-featured-projects]').forEach(function (root) {
      var imgs = root.querySelectorAll('[data-project-panel] img[loading="lazy"]');
      if (!imgs.length) return;

      var preload = function () {
        imgs.forEach(function (img) {
          img.loading = 'eager';
        });
      };

      if (!('IntersectionObserver' in window)) {
        preload();
        return;
      }

      var io = new IntersectionObserver(
        function (entries) {
          if (entries.some(function (entry) { return entry.isIntersecting; })) {
            io.disconnect();
            preload();
          }
        },
        { rootMargin: '100% 0px' }
      );
      io.observe(root);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  function updateHeaderHeightVar() {
    const root = document.documentElement;
    const headerGroup = document.querySelector('.shopify-section-group-header-group');

    if (!root || !headerGroup) {
      return;
    }

    const height = Math.round(headerGroup.getBoundingClientRect().height);
    root.style.setProperty('--header-height', `${height}px`);
  }

  function initHeaderHeightVar() {
    updateHeaderHeightVar();

    const headerGroup = document.querySelector('.shopify-section-group-header-group');
    if (!headerGroup) {
      return;
    }

    const observer = new ResizeObserver(() => {
      updateHeaderHeightVar();
    });

    observer.observe(headerGroup);
    window.addEventListener('resize', updateHeaderHeightVar, { passive: true });
    window.addEventListener('scroll', updateHeaderHeightVar, { passive: true });
    document.addEventListener('shopify:section:load', updateHeaderHeightVar);
    document.addEventListener('shopify:section:reorder', updateHeaderHeightVar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeaderHeightVar, { once: true });
  } else {
    initHeaderHeightVar();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["insights"] && !Shopify.designMode) return;
  try {
    
  // Assigns column spans so rows are always filled on 2- and 3-column layouts.
  function insightsLayout(visibleCards) {
    const spanClasses = ['md:col-span-1', 'md:col-span-2', 'lg:col-span-1', 'lg:col-span-2', 'lg:col-span-3'];
    const widePositions = [3, 6, 10];
    const cycleLength = 15;
    const count = visibleCards.length;
    let usedMd = 0;
    let usedLg = 0;

    visibleCards.forEach((card, index) => {
      const remaining = count - index;

      let spanLg = widePositions.includes(index % cycleLength) ? 2 : 1;
      const freeLg = 3 - usedLg;
      if (spanLg > freeLg) spanLg = freeLg;
      if (remaining === 1) spanLg = freeLg;
      if (remaining === 2 && freeLg === 3) spanLg = 2;
      usedLg = (usedLg + spanLg) % 3;

      let spanMd = 1;
      const freeMd = 2 - usedMd;
      if (remaining === 1) spanMd = freeMd;
      usedMd = (usedMd + spanMd) % 2;

      card.hidden = false;
      card.style.order = index;
      card.classList.remove(...spanClasses);
      card.classList.add('md:col-span-' + spanMd, 'lg:col-span-' + spanLg);
    });
  }

  // On narrow screens the tab strip scrolls horizontally; bring the active tab into view.
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.insights-tabs').forEach((strip) => {
      const active = strip.querySelector('.is-active');
      if (!active || strip.scrollWidth <= strip.clientWidth) return;
      const item = active.closest('li') || active;
      strip.scrollLeft = item.offsetLeft - (strip.clientWidth - item.offsetWidth) / 2;
    });
  });

  document.addEventListener('alpine:init', () => {
    // Hub: one merged, newest-first feed of every blog.
    Alpine.data('insightsFeed', (config) => ({
      perPage: config.perPage || 15,
      shown: config.perPage || 15,
      total: 0,
      visible: 0,
      loading: false,
      feeds: {},

      init() {
        this.$root.querySelectorAll('[data-feed-handle]').forEach((el) => {
          const count = parseInt(el.dataset.feedCount, 10) || 0;
          const pages = Math.ceil(count / config.fetchSize);
          const loaded = new Set();
          for (let page = 1; page <= Math.min(pages, config.preloadPages); page += 1) {
            loaded.add(page);
          }
          this.feeds[el.dataset.feedHandle] = {
            handle: el.dataset.feedHandle,
            label: el.dataset.feedLabel,
            url: el.dataset.feedUrl,
            count,
            pages,
            loaded,
            failed: false,
          };
        });

        // Category filters used to live on the hub as ?category=<handle>; each blog now has its own archive.
        const requested = new URLSearchParams(window.location.search).get('category');
        if (requested && this.feeds[requested]) {
          window.location.replace(this.feeds[requested].url);
          return;
        }

        this.apply();
      },

      loadMore() {
        this.shown += this.perPage;
        this.apply();
      },

      cards() {
        return Array.from(this.$refs.grid.querySelectorAll('[data-article]'));
      },

      // Number of pages loaded contiguously from the newest end.
      contiguousPages(feed) {
        let count = 0;
        for (let page = 1; page <= feed.pages; page += 1) {
          if (!feed.loaded.has(page)) break;
          count += 1;
        }
        return count;
      },

      nextPage(feed) {
        if (feed.failed) return null;
        const contiguous = this.contiguousPages(feed);
        if (contiguous >= feed.pages) return null;
        return contiguous + 1;
      },

      apply() {
        const feeds = Object.values(this.feeds);
        const cards = this.cards();
        cards.sort((a, b) => parseInt(b.dataset.ts, 10) - parseInt(a.dataset.ts, 10));

        // Articles older than this timestamp may still be missing from unloaded pages.
        let cutoff = null;
        feeds.forEach((feed) => {
          const contiguous = this.contiguousPages(feed);
          if (contiguous >= feed.pages) return;
          const safeCards = cards.filter(
            (card) => card.dataset.blog === feed.handle && parseInt(card.dataset.page, 10) <= contiguous
          );
          if (!safeCards.length) {
            cutoff = Infinity;
            return;
          }
          const boundary = parseInt(safeCards[safeCards.length - 1].dataset.ts, 10);
          cutoff = cutoff === null ? boundary : Math.max(cutoff, boundary);
        });

        const safe = cutoff === null ? cards : cards.filter((card) => parseInt(card.dataset.ts, 10) >= cutoff);

        let total = feeds.reduce((sum, feed) => sum + feed.count, 0);
        if (config.featuredId) {
          total -= 1;
        }

        const target = Math.min(this.shown, total);
        const visibleCards = safe.slice(0, target);

        cards.forEach((card) => {
          card.hidden = true;
          card.style.order = '';
        });

        insightsLayout(visibleCards);

        this.total = total;
        this.visible = visibleCards.length;

        if (visibleCards.length < target && !this.loading) {
          this.fetchMore();
        }
      },

      async fetchMore() {
        const targets = Object.values(this.feeds).filter((feed) => this.nextPage(feed) !== null);
        if (!targets.length) return;

        this.loading = true;

        await Promise.all(
          targets.map(async (feed) => {
            const page = this.nextPage(feed);
            try {
              const separator = feed.url.includes('?') ? '&' : '?';
              const response = await fetch(feed.url + separator + 'view=insights-feed&page=' + page, {
                headers: { 'X-Requested-With': 'XMLHttpRequest' },
              });
              if (!response.ok) throw new Error('HTTP ' + response.status);
              const html = await response.text();
              const doc = new DOMParser().parseFromString(html, 'text/html');
              const container = doc.querySelector('[data-insights-feed]');
              if (!container) throw new Error('Feed container missing');

              const existing = new Set(this.cards().map((card) => card.dataset.id));
              container.querySelectorAll('[data-article]').forEach((card) => {
                if (card.dataset.id === config.featuredId || existing.has(card.dataset.id)) return;
                card.dataset.page = page;
                this.$refs.grid.appendChild(card);
              });

              feed.pages = parseInt(container.dataset.pages, 10) || feed.pages;
              feed.loaded.add(page);
            } catch (error) {
              console.error('Insights feed error:', error);
              feed.failed = true;
            }
          })
        );

        this.loading = false;
        this.apply();
      },
    }));

    // Blog archive: server-paginated; "load more" appends the next page in place.
    Alpine.data('insightsArchive', () => ({
      total: 0,
      visible: 0,
      loading: false,
      next: true,

      init() {
        this.total = parseInt(this.$refs.grid.dataset.total, 10) || 0;
        this.layout();
      },

      cards() {
        return Array.from(this.$refs.grid.querySelectorAll('[data-article]'));
      },

      layout() {
        const cards = this.cards();
        insightsLayout(cards);
        // The featured article sits above the grid on the first page.
        this.visible = cards.length + (this.$root.querySelector('.insights-featured') ? 1 : 0);
      },

      async loadMore(link) {
        if (this.loading) return;
        this.loading = true;
        try {
          const url = new URL(link.href);
          url.searchParams.set('view', 'insights-feed');
          const response = await fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
          if (!response.ok) throw new Error('HTTP ' + response.status);
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const container = doc.querySelector('[data-insights-feed]');
          if (!container) throw new Error('Feed container missing');

          const existing = new Set(this.cards().map((card) => card.dataset.id));
          container.querySelectorAll('[data-article]').forEach((card) => {
            if (existing.has(card.dataset.id)) return;
            this.$refs.grid.appendChild(card);
          });
          this.layout();

          const page = parseInt(container.dataset.page, 10);
          const pages = parseInt(container.dataset.pages, 10);
          if (page < pages) {
            url.searchParams.delete('view');
            url.searchParams.set('page', page + 1);
            link.href = url.pathname + url.search;
          } else {
            this.next = false;
          }
        } catch (error) {
          // Fall back to a normal navigation to the next page.
          console.error('Insights archive error:', error);
          window.location.href = link.href;
        }
        this.loading = false;
      },
    }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multicolumn"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-multicolumn-embla]').forEach(function (root) {
      var viewport = root.querySelector('[data-multicolumn-embla-viewport]');
      if (!viewport || !window.EmblaCarousel) {
        return;
      }

      var embla = EmblaCarousel(viewport, {
        align: 'start',
        containScroll: 'trimSnaps',
        loop: false,
        slidesToScroll: 1,
        breakpoints: {
          '(min-width: 768px)': { active: false }
        }
      });

      var prevBtn = root.querySelector('[data-multicolumn-embla-prev]');
      var nextBtn = root.querySelector('[data-multicolumn-embla-next]');

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          embla.scrollPrev();
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          embla.scrollNext();
        });
      }

      var progressNode = root.querySelector('[data-multicolumn-embla-progress]');
      var progressTrack = root.querySelector('[data-multicolumn-embla-progress-track]');
      if (!progressNode) {
        return;
      }

      var updateProgress = function () {
        var progress = Math.max(0, Math.min(1, embla.scrollProgress()));
        var minFill = 0.15;
        progressNode.style.transform = 'scaleX(' + (minFill + progress * (1 - minFill)) + ')';
      };

      embla.on('scroll', updateProgress);
      embla.on('reInit', updateProgress);
      updateProgress();

      if (!progressTrack) {
        return;
      }

      var isPointerDown = false;

      var moveToProgress = function (event) {
        var snapList = embla.scrollSnapList();
        if (!snapList.length) {
          return;
        }

        var rect = progressTrack.getBoundingClientRect();
        var target = Math.max(0, Math.min(1, (event.clientX - rect.left) / rect.width));
        var closestIndex = 0;

        snapList.forEach(function (snap, index) {
          if (Math.abs(snap - target) < Math.abs(snapList[closestIndex] - target)) {
            closestIndex = index;
          }
        });

        embla.scrollTo(closestIndex);
      };

      progressTrack.addEventListener('pointerdown', function (event) {
        isPointerDown = true;
        progressTrack.setPointerCapture(event.pointerId);
        moveToProgress(event);
      });

      progressTrack.addEventListener('pointermove', function (event) {
        if (isPointerDown) {
          moveToProgress(event);
        }
      });

      var onPointerUp = function (event) {
        if (!isPointerDown) {
          return;
        }
        isPointerDown = false;
        progressTrack.releasePointerCapture(event.pointerId);
      };

      progressTrack.addEventListener('pointerup', onPointerUp);
      progressTrack.addEventListener('pointercancel', onPointerUp);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["posts"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var emblaRoots = document.querySelectorAll('[data-posts-embla]');

    emblaRoots.forEach(function (root) {
      var viewport = root.querySelector('[data-posts-embla-viewport]');
      if (!viewport || !window.EmblaCarousel) {
        return;
      }

      var embla = EmblaCarousel(viewport, {
        align: 'start',
        containScroll: 'trimSnaps',
        dragFree: false,
        loop: false,
        slidesToScroll: 1,
        breakpoints: {
          '(min-width: 1024px)': { slidesToScroll: 2 }
        }
      });

      var prevBtn = root.querySelector('[data-posts-embla-prev]');
      var nextBtn = root.querySelector('[data-posts-embla-next]');

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          embla.scrollPrev();
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          embla.scrollNext();
        });
      }

      var progressNode = root.querySelector('[data-posts-embla-progress]');
      var progressTrack = root.querySelector('[data-posts-embla-progress-track]');
      if (!progressNode) {
        return;
      }

      var updateProgress = function () {
        var progress = embla.scrollProgress();
        var clampedProgress = Math.max(0, Math.min(1, progress));
        var minFill = 0.15;
        var fill = minFill + clampedProgress * (1 - minFill);
        progressNode.style.transform = 'scaleX(' + fill + ')';
      };

      embla.on('scroll', updateProgress);
      embla.on('reInit', updateProgress);
      updateProgress();

      if (!progressTrack) {
        return;
      }

      var snapList = embla.scrollSnapList();
      var isPointerDown = false;

      var findClosestSnap = function (progress) {
        var closestIndex = 0;
        var closestDistance = Math.abs(snapList[0] - progress);

        snapList.forEach(function (snap, index) {
          var distance = Math.abs(snap - progress);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });

        return closestIndex;
      };

      var moveToProgress = function (event) {
        var rect = progressTrack.getBoundingClientRect();
        var raw = (event.clientX - rect.left) / rect.width;
        var clamped = Math.max(0, Math.min(1, raw));
        var index = findClosestSnap(clamped);
        embla.scrollTo(index);
      };

      var onPointerDown = function (event) {
        isPointerDown = true;
        progressTrack.setPointerCapture(event.pointerId);
        moveToProgress(event);
      };

      var onPointerMove = function (event) {
        if (!isPointerDown) {
          return;
        }

        moveToProgress(event);
      };

      var onPointerUp = function (event) {
        if (!isPointerDown) {
          return;
        }

        isPointerDown = false;
        progressTrack.releasePointerCapture(event.pointerId);
      };

      progressTrack.addEventListener('pointerdown', onPointerDown);
      progressTrack.addEventListener('pointermove', onPointerMove);
      progressTrack.addEventListener('pointerup', onPointerUp);
      progressTrack.addEventListener('pointercancel', onPointerUp);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-featured-gallery"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var SELECTOR = '[data-product-featured-gallery]';
    var AUTOSLIDE_MS = 7000;

    var withEmbla = function (onReady, onFail, attempt) {
      var currentAttempt = attempt || 0;

      if (window.EmblaCarousel) {
        onReady(window.EmblaCarousel);
        return;
      }

      if (currentAttempt >= 40) {
        if (onFail) {
          onFail();
        }
        return;
      }

      setTimeout(function () {
        withEmbla(onReady, onFail, currentAttempt + 1);
      }, 50);
    };

    var initRoot = function (root) {
      if (!root || root.dataset.emblaInitialized === 'true' || root.dataset.emblaInitializing === 'true') {
        return;
      }

      var viewport = root.querySelector('[data-product-featured-gallery-viewport]');
      if (!viewport) {
        return;
      }

      root.dataset.emblaInitializing = 'true';

      withEmbla(
        function (EmblaCarouselRef) {
          var embla = EmblaCarouselRef(viewport, {
            align: 'start',
            containScroll: 'trimSnaps',
            dragFree: false,
            loop: true,
            slidesToScroll: 1
          });

          root.dataset.emblaInitialized = 'true';
          root.dataset.emblaInitializing = 'false';
          root.emblaApi = embla;

          var stopAutoSlide = function () {
            if (root.autoslideTimer) {
              clearInterval(root.autoslideTimer);
              root.autoslideTimer = null;
            }
          };

          var startAutoSlide = function () {
            stopAutoSlide();

            root.autoslideTimer = setInterval(function () {
              if (root.emblaApi) {
                root.emblaApi.scrollNext();
              }
            }, AUTOSLIDE_MS);
          };

          if (root.dataset.autoslideBound !== 'true') {
            root.dataset.autoslideBound = 'true';

            root.addEventListener('mouseenter', stopAutoSlide);
            root.addEventListener('mouseleave', startAutoSlide);
            root.addEventListener('focusin', stopAutoSlide);
            root.addEventListener('focusout', startAutoSlide);
          }

          embla.on('pointerDown', stopAutoSlide);
          embla.on('pointerUp', startAutoSlide);

          startAutoSlide();
        },
        function () {
          root.dataset.emblaInitializing = 'false';
        }
      );
    };

    var initAll = function (scope) {
      var container = scope || document;
      var roots = container.querySelectorAll(SELECTOR);
      roots.forEach(initRoot);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll(document);
      });
    } else {
      initAll(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });

    document.addEventListener('shopify:section:unload', function (event) {
      var roots = event.target.querySelectorAll(SELECTOR);

      roots.forEach(function (root) {
        if (root.autoslideTimer) {
          clearInterval(root.autoslideTimer);
          root.autoslideTimer = null;
        }

        if (root.emblaApi && typeof root.emblaApi.destroy === 'function') {
          root.emblaApi.destroy();
          root.emblaApi = null;
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-manual"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('alpine:init', () => {
    Alpine.data('productManual', () => ({
      active: 0,
      chapters: [],
      isVisible: false,
      hasLoaded: false,
      embla: null,
      init() {
        try {
          this.chapters = JSON.parse(this.$root.dataset.chapters || '[]');
        } catch (e) {
          this.chapters = [];
        }
        this.observeVisibility();
        this.observeThumbs();
        this.initCarousel();
      },
      observeThumbs() {
        var thumbs = this.$root.querySelectorAll('.product-manual__thumb-video');
        if (!('IntersectionObserver' in window)) {
          thumbs.forEach(function (v) {
            if (v.dataset.src) { v.src = v.dataset.src; v.preload = 'metadata'; }
          });
          return;
        }
        var observer = new IntersectionObserver(function (entries, obs) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            var v = entry.target;
            if (v.dataset.src && !v.src) {
              v.src = v.dataset.src;
              v.preload = 'metadata';
            }
            obs.unobserve(v);
          });
        }, { rootMargin: '300px 0px', threshold: 0.01 });
        thumbs.forEach(function (v) { observer.observe(v); });
      },
      initCarousel() {
        var self = this;
        var viewport = this.$root.querySelector('[data-product-manual-viewport]');
        if (!viewport) return;
        var start = function () {
          if (!window.EmblaCarousel) {
            return setTimeout(start, 50);
          }
          self.embla = window.EmblaCarousel(viewport, {
            align: 'start',
            containScroll: 'trimSnaps',
            loop: false,
            slidesToScroll: 1,
          });
        };
        start();
      },
      setActive(i) {
        if (i < 0 || i >= this.chapters.length) return;
        this.active = i;
        this.loadChapter(i, true);
        if (this.embla) this.embla.scrollTo(i);
      },
      next() {
        this.setActive(Math.min(this.active + 1, this.chapters.length - 1));
      },
      prev() {
        this.setActive(Math.max(this.active - 1, 0));
      },
      loadChapter(i, autoplay) {
        var video = this.$refs.mainVideo;
        if (!video) return;
        var chapter = this.chapters[i];
        if (!chapter || !chapter.video) return;
        video.pause();
        video.src = autoplay ? chapter.video : chapter.video + '#t=2';
        video.load();
        if (autoplay) {
          video.play().catch(function () {});
        }
      },
      observeVisibility() {
        var self = this;
        if (!('IntersectionObserver' in window)) {
          this.isVisible = true;
          this.loadChapter(0, false);
          return;
        }
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              self.isVisible = entry.isIntersecting;
              var video = self.$refs.mainVideo;
              if (!video) return;
              if (entry.isIntersecting && !self.hasLoaded) {
                self.hasLoaded = true;
                self.loadChapter(self.active, false);
              }
              if (!entry.isIntersecting && !video.paused) {
                video.pause();
              }
            });
          },
          { threshold: 0.1, rootMargin: '200px 0px' }
        );
        observer.observe(this.$root);
      },
    }));
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["timeline"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var emblaRoots = document.querySelectorAll('[data-timeline-embla]');

    emblaRoots.forEach(function (root) {
      var viewport = root.querySelector('[data-timeline-embla-viewport]');
      if (!viewport || !window.EmblaCarousel) {
        return;
      }

      var embla = EmblaCarousel(viewport, {
        align: 'start',
        containScroll: 'trimSnaps',
        dragFree: false,
        loop: false
      });

      var prevBtn = root.querySelector('[data-timeline-embla-prev]');
      var nextBtn = root.querySelector('[data-timeline-embla-next]');

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          embla.scrollPrev();
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          embla.scrollNext();
        });
      }

      var progressNode = root.querySelector('[data-timeline-embla-progress]');
      var progressTrack = root.querySelector('[data-timeline-embla-progress-track]');
      if (!progressNode) {
        return;
      }

      var updateProgress = function () {
        var progress = embla.scrollProgress();
        var clampedProgress = Math.max(0, Math.min(1, progress));
        var minFill = 0.15;
        var fill = minFill + clampedProgress * (1 - minFill);
        progressNode.style.transform = 'scaleX(' + fill + ')';
      };

      embla.on('scroll', updateProgress);
      embla.on('reInit', updateProgress);
      updateProgress();

      if (!progressTrack) {
        return;
      }

      var snapList = embla.scrollSnapList();
      var isPointerDown = false;

      var findClosestSnap = function (progress) {
        var closestIndex = 0;
        var closestDistance = Math.abs(snapList[0] - progress);

        snapList.forEach(function (snap, index) {
          var distance = Math.abs(snap - progress);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });

        return closestIndex;
      };

      var moveToProgress = function (event) {
        var rect = progressTrack.getBoundingClientRect();
        var raw = (event.clientX - rect.left) / rect.width;
        var clamped = Math.max(0, Math.min(1, raw));
        var index = findClosestSnap(clamped);
        embla.scrollTo(index);
      };

      var onPointerDown = function (event) {
        isPointerDown = true;
        progressTrack.setPointerCapture(event.pointerId);
        moveToProgress(event);
      };

      var onPointerMove = function (event) {
        if (!isPointerDown) {
          return;
        }
        moveToProgress(event);
      };

      var onPointerUp = function (event) {
        if (!isPointerDown) {
          return;
        }
        isPointerDown = false;
        progressTrack.releasePointerCapture(event.pointerId);
      };

      progressTrack.addEventListener('pointerdown', onPointerDown);
      progressTrack.addEventListener('pointermove', onPointerMove);
      progressTrack.addEventListener('pointerup', onPointerUp);
      progressTrack.addEventListener('pointercancel', onPointerUp);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
